import {ChangeDetectorRef, Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';


const MINUTES = 60;
const HOURS = 3600;


const DAY = 86399; // 00:00:00-23:59:59

@Component({
    selector: 'app-schedule-timeline',
    templateUrl: './schedule-timeline.component.html',
    styleUrls: ['./schedule-timeline.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ScheduleTimelineComponent implements OnInit, OnChanges {


  @Input() periods = [];
  @ViewChild('container', {static: true}) container;

  constructor(private cdr: ChangeDetectorRef) {

  }

  periodTimes = [];

  times = ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'];
  timesShort = ['00:00', '04:00', '08:00', '12:00', '16:00', '20:00', '24:00'];
  renderTime = [];
  isShortType = false;

  selected = null;

  @HostListener('window:resize', ['$event'])
  onResize = _.throttle((event) => {
    this.checkSize();
  }, 100);

  ngOnInit() {
    this.checkSize();
    this.prepareData();
  }

  ngOnChanges() {
    this.prepareData();
  }

  prepareData() {
    this.periodTimes = this.periods.map(val => {
      const from = val.from.split(':');
      const to = val.to.split(':');
      const fromPercent = (from[0] * HOURS + from[1] * MINUTES + from[2]) / DAY;
      const toPercent = (to[0] * HOURS + to[1] * MINUTES + to[2]) / DAY;
      return {
        from: val.from,
        to: val.to,
        left: fromPercent,
        width: toPercent - fromPercent,
      };
    });
  }

  checkSize() {

    this.isShortType = this.container.nativeElement.offsetWidth < 600;
    this.renderTime = this.isShortType ? this.timesShort : this.times;

    this.cdr.detectChanges();
  }


  onMouseEnter(time) {
    this.selected = time;
    this.cdr.detectChanges();
  }

  onMouseLeave(time) {
    if (this.selected === time) {
      this.selected = null;
      this.cdr.detectChanges();
    }
  }
}
